/**
 * A component to make sure the page scrolls to the top when the route changes.
 * Reference: https://dev.to/kunalukey/scroll-to-top-when-route-changes-reactjs-react-router-3bgn
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, state]);
};

export default ScrollToTop;
